/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LandingHeroSection.vue?vue&type=template&id=c456dd7c"
import script from "./LandingHeroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingHeroSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LandingHeroSection.vue?vue&type=style&index=0&id=c456dd7c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports